// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".app-msel-aync-chbox{width:100%}.app-msel-aync-chbox .v-input__control{width:100%}.app-msel-aync-chbox.v-input--selection-controls.v-input .v-label{display:block}", ""]);
// Exports
module.exports = exports;
